import React, { useEffect, useState } from 'react';
import { Dialog } from '@material-ui/core';
import { getFilePreviewURL } from 'hooks/useFileUpload';
import { LoadingBounce } from '@michelin/acid-components';
import { FOOTERED_CONTENT_AREA_HEIGHT } from 'Utils';
import { ClosableDialogTitle } from 'components/ClosableDialog/ClosableDialogTitle';
import { ClosableDialogContent } from 'components/ClosableDialog/ClosableDialogContent';
import { FileData } from './FileUpload';

interface FileModalPreviewProps {
  title: string,
  fileData: FileData,
  onClose?: () => void
}

function FileModalPreview({ title, fileData, onClose }: FileModalPreviewProps) {
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [size, setSize] = useState({ width: '0', height: '0' });

  useEffect(() => {
    async function fetchFileUrl() {
      const downloadInfo = await getFilePreviewURL(fileData.id, fileData.name);

      if (downloadInfo) {
        setFileUrl(downloadInfo.url);
        setSize({ width: '100%', height: FOOTERED_CONTENT_AREA_HEIGHT });
      }
    }

    fetchFileUrl();
  }, [fileData]);

  return (
    <Dialog
      onClose={() => onClose?.()}
      aria-labelledby="customized-dialog-title"
      open
      fullWidth
      maxWidth="md"
      scroll="paper"
      disableBackdropClick
    >
      <ClosableDialogTitle onClose={() => onClose?.()}>
        {title}
      </ClosableDialogTitle>

      <ClosableDialogContent dividers>
        {(fileUrl
          ? (<embed type={fileData.mime} src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`} style={{ width: size.width, height: size.height, objectFit: 'scale-down' }} />)
          : (<LoadingBounce style={{ zIndex: 1300, height: 350 }} />)
        )}
      </ClosableDialogContent>
    </Dialog>
  );
}

export default FileModalPreview;
